import { render, staticRenderFns } from "./ColumnDataValueTotal.vue?vue&type=template&id=e9822d6c"
import script from "./ColumnDataValueTotal.vue?vue&type=script&lang=js"
export * from "./ColumnDataValueTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports